<div class="cpp-input--error" *ngIf="control?.invalid && (control?.touched)">
    <span class="cpp-input--error__icon icon icon--small">
      <svg>
        <use xlink:href="#Error"></use>
      </svg>
    </span>
    <span class="cpp-input--error__message">{{ showError(control.errors) }}</span>
</div>

